import React, { useState } from 'react';
import 'antd/dist/antd.css';
import './block-builder.css';
import FeaturedCollections from './FeaturedCollections';
import HighlightItem from './HighlightItem';
import FeaturedCategories from './FeaturedCategories';
import FullFeature from './FullFeature';
import { Divider, Input, Button, message } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';

function App() {
  const [featuredCollections, setCollections] = useState("");
  const [highlightItem, setHighlight] = useState("");
  const [featuredCategories, setCategories] = useState("");
  const [fullFeature, setFeature] = useState("");
  const copyMsg = () => {message.success('Copied!');};
  const { TextArea } = Input;
  const combinedCode = featuredCollections + highlightItem + featuredCategories + fullFeature;

  return (
    <div className="App">
      <FeaturedCollections setCodeBlock={setCollections} />
      <Divider />
      <HighlightItem setCodeBlock={setHighlight} />
      <Divider />
      <FeaturedCategories setCodeBlock={setCategories} />
      <Divider />
      <FullFeature setCodeBlock={setFeature}/>
      <Divider />

      <div className="blockCode container">
        <h2>Code For All Blocks</h2>
        <TextArea rows={15} readOnly value={combinedCode} />
        <CopyToClipboard text={combinedCode}>
            <Button type="primary" onClick={copyMsg}>Copy all to clipboard</Button>
        </CopyToClipboard>
      </div>
    </div>
  );
}

export default App;
